import React from 'react';
import PropTypes from 'prop-types';

import { IMG_CHAT_INTERFACE } from '../../../../../../data/assets/img';

import ChatBody from '../../../../components/chatinterface/components/chatbody';
import ModalFooter from '../../../../../../components/modalfooter';

class FeedbackChatlog extends React.PureComponent {
    setChatlogContainerRef = el => { this.chatlogContainer = el; }

    render() {
        const { messages, button_ok_text, handleOkClick, active_chat_item } = this.props;
        return (
            <div className="ori-relative ori-full-parent-height ori-b-pad-65 ori-bg-size-cover ori-bg-no-repeat" style={{ backgroundImage: `url(${IMG_CHAT_INTERFACE})` }}>
                <div className="ori-full-parent-height ori-overflow-y-auto ori-overflow-x-hidden" ref={this.setChatlogContainerRef} >
                    <ChatBody active_chat_item={active_chat_item} chatContainer={this.chatlogContainer} messages={messages} />
                </div>
                <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter button_ok_text={button_ok_text} handleOkClick={handleOkClick} capsule_button hide_cancel_button />
                </div>
            </div>
        );
    }
}

FeedbackChatlog.propTypes = {
    messages: PropTypes.array.isRequired,
    button_ok_text: PropTypes.string,
    handleOkClick: PropTypes.func,
    active_chat_item: PropTypes.object,
};

export default FeedbackChatlog;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/feedback/feedbackchatlog/index.js